var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{class:`icon icon-${_vm.name}`,attrs:{"aria-hidden":_vm.label === '' ? 'true' : 'false',"aria-label":_vm.label || undefined}})
}
var staticRenderFns = []

export { render, staticRenderFns }